import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`
  return config
})

export function getSalesAgents(): Promise<{data: any}> {
  return adminApi.get(`${API_URL}/admin/sales-agents`)
}
export function rebuildSalesAgents(): Promise<{data: any}> {
  return adminApi.post(`${API_URL}/admin/sales-agents/rebuild`, {})
}
export function getRebuildStatus(): Promise<{data: any}> {
  return adminApi.get(`${API_URL}/admin/sales-agents/rebuild-status`)
}
export function analyzeAgent(id: string): Promise<{data: any}> {
  return adminApi.post(`${API_URL}/admin/sales-agents/${id}/analyze`, {})
}
export function updateAgent(id: string, data: {company_name?: string; city?: string; is_real_estate?: boolean; excluded?: boolean}): Promise<{data: any}> {
  return adminApi.put(`${API_URL}/admin/sales-agents/${id}`, data)
}
export function addCity(name: string): Promise<{data: any}> {
  return adminApi.post(`${API_URL}/admin/sales-agents/cities`, {name})
}
export function renameCity(id: string, name: string): Promise<{data: any}> {
  return adminApi.put(`${API_URL}/admin/sales-agents/cities/${id}`, {name})
}
export function deleteCity(id: string): Promise<{data: any}> {
  return adminApi.delete(`${API_URL}/admin/sales-agents/cities/${id}`)
}
